import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import CardBackground from "./CardBackground";
import { confirmAlert } from "react-confirm-alert";
import { useAtom } from "jotai";
import { gbState, globalUserStatus } from "../../components/shared/GlobalState";

const AdminMenuSection = ({ setChurchOnBoardShow }) => {
  const [{ errorLogApi, placeHolderText, Category, user }] = useAtom(gbState);
  const [userGlobal, setUserGlobal] = useAtom(globalUserStatus);
  const [buddies, setBuddies] = useState();
  const [updatedUser, setUpdatedUser] = useState();

  useEffect(() => {
    let userToken = localStorage.getItem("token");
    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/user/buddies-details`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: { buddies: userGlobal?.buddyRequests },
    };

    axios(config)
      .then(function (response) {
        //toast.success("Request Sent Successfully.");

        setBuddies(response?.data);
      })
      .catch(function (error) {
        toast.error(error?.response?.data?.message);
        errorLogApi(error, "AssetInwardChild", "/asset/add");
        // console.log(error);
      });
  }, [userGlobal]);

  const updateUserDetailRealtime = () => {
    let userToken = localStorage.getItem("token");
    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/user/refresh-user`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: { userId: userGlobal?._id },
    };

    axios(config)
      .then(function (response) {
        //toast.success("Request Sent Successfully.");

        setUpdatedUser(response?.data);
        setUserGlobal({ ...userGlobal, ...response?.data });
      })
      .catch(function (error) {
        toast.error(error?.response?.data?.message);
        errorLogApi(error, "AssetInwardChild", "/asset/add");
        // console.log(error);
      });
  };

  return (
    <div>
      <CardBackground>
        <div className="flex flex-col items-center w-full p-6 bg-white border border-gray-100 rounded-lg shadow-sm">
          <div className="flex items-center mb-4">
            <svg
              className="w-6 h-6 mr-2 text-blue-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
              />
            </svg>
            <h2 className="text-lg font-semibold text-gray-800">
              Church Onboarding
            </h2>
          </div>

          <p className="mb-6 text-center text-gray-600">
            Ready to add a new church to the platform? Start the onboarding
            process here.
          </p>

          <button
            className="flex items-center px-6 py-3 text-sm font-medium text-white transition-all duration-200 bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5"
            onClick={() => setChurchOnBoardShow(true)}
          >
            <svg
              className="w-5 h-5 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
              />
            </svg>
            ONBOARD NEW CHURCH
          </button>
        </div>
      </CardBackground>
    </div>
  );
};

export default AdminMenuSection;
